module.exports = __webpack_public_path__ + "img/sl-header-logo.96fab2c2.png";